import { Component } from "react";
import { connect } from "react-redux";
import "./Notification.css";
import { Drawer, Button, Modal, Dropdown, Tabs, Badge } from "antd";
import {
    DeleteOutlined,
    EllipsisOutlined,
    CheckOutlined,
    CalendarOutlined,
    SettingOutlined
} from "@ant-design/icons";
import { clearNotifications, markNotificationsAsRead, updateNotificationStatus } from "../../../redux/actions/notification/notification";
import SystemNotificationsList from "./SystemNotificationList";

import API from "../../../utils/API/API";
import ActivityNotificationsList from "./ActivityNotificationList";
import { BellIcon, BellOffIcon } from "./SoundIcons";

class NotificationDrawer extends Component {
    state = {
        muted: JSON.parse(localStorage.getItem('notificationSoundMuted')) || false,
    };

    handleNotificationClick(url, notification) {
        this.props.handleDrawer(false);
        if (!notification.read) {
            API.patch(`/api/notifications/mark-as-read`, {
                _id: notification._id,
            })
                .then(() => {
                    this.props.updateNotificationStatus(notification._id)
                    this.handleRedirect(url, notification.type === "System" ? true : false, notification.type === "Gift Card" ? true : false);
                })
                .catch((e) => {
                    this.handleRedirect(url, notification.type === "System" ? true : false, notification.type === "Gift Card" ? true : false);
                });
        } else {
            this.handleRedirect(url, notification.type === "System" ? true : false, notification.type === "Gift Card" ? true : false);
        }
    }

    handleNotificationAsRead(notification) {
        if (!notification.read) {
            API.patch(`/api/notifications/mark-as-read`, {
                _id: notification._id,
            }).then(() => {
                this.props.updateNotificationStatus(notification._id)
            }).catch((e) => {

            });
        }
    }

    handleRedirect = (url, newTab, forceRefresh) => {
        const pathname = url.substring(0, url.indexOf("?"));
        const search = url.substring(url.indexOf("?"));
        if (newTab) {
            const win = window.open(search, "_blank");
            win.focus();
        } else {
            this.props.history.push({
                pathname,
                search,
                state: { isFromApplication: true },
            });
            if (forceRefresh) {
                this.props.history.go(0)
            }
        }
    };


    warningClearNotificationModal = () => {
        Modal.confirm({
            title: 'Clear Notifications',
            content: 'Are you sure you want to clear all notifications? This action cannot be undone!',
            closable: true,
            maskClosable: true,
            onOk: () => {
                this.props.clearNotifications()
                this.props.handleDrawer(false)
            },
            okText: "Yes",
            cancelText: "Cancel",
        });
    };

    handleMuteUnmute = () => {
        let muted = !this.state.muted;
        this.setState({ muted });
        localStorage.setItem('notificationSoundMuted', muted.toString());
    }




    render() {
        const {
            showDrawer,
            notifications,
            countNotifications,
            loadingNotifications,
            unreadNotifications,
            unreadSystemNotifications,
            isMobile
        } = this.props;

        const unreadActivityNotifications = Math.max(
            0,
            unreadNotifications - unreadSystemNotifications
        );


        return (
            <Drawer
                title={<div style={{ display: "flex", alignItems: "center" }}>
                    Notifications
                    <Button style={{ marginLeft: 10 }} variant="text" color={this.state.muted ? "danger" : "primary"} onClick={this.handleMuteUnmute}>
                        {this.state.muted ? <BellOffIcon /> : <BellIcon />}
                    </Button>
                </div>}
                extra={
                    (countNotifications.unreadNotifications > 0 || countNotifications.totalNotifications > 0) && (
                        <Dropdown
                            trigger={["click"]}
                            menu={{
                                items: [
                                    countNotifications.unreadNotifications > 0 && {
                                        key: "mark all as read",
                                        label: (
                                            <Button
                                                type="link"
                                                icon={<CheckOutlined />}
                                                onClick={() => {
                                                    this.props.markNotificationsAsRead()
                                                    this.props.handleDrawer(false)
                                                }}
                                            >
                                                Mark all as read
                                            </Button>
                                        ),
                                    },
                                    countNotifications.totalNotifications > 0 && {
                                        key: "clear notifications",
                                        label: (
                                            <Button
                                                type="link"
                                                icon={<DeleteOutlined />}
                                                danger
                                                onClick={this.warningClearNotificationModal}
                                            >
                                                Clear notifications
                                            </Button>
                                        ),
                                    },
                                ].filter(Boolean),
                            }}
                        >
                            <Button shape="circle" icon={<EllipsisOutlined />} />
                        </Dropdown>
                    )
                }
                placement="right"
                closable={false}
                onClose={(_) => this.props.handleDrawer(false)}
                open={showDrawer}
                width={!isMobile ? "30%" : 300}
            >
                <Tabs type="card" defaultActiveKey="1" items={[
                    {
                        key: "1",
                        label: (
                            <>
                                {isMobile ? <CalendarOutlined /> : "Activity"} {" "}
                                <Badge count={unreadActivityNotifications} overflowCount={99} />
                            </>
                        ),
                        children: <ActivityNotificationsList
                            pageSize={10}
                            // If you don't have totalSystemNotifications, you can omit totalActivityCount and pass counts:
                            // counts={countNotifications} // we will fall back to totalNotifications - unreadSystemNotifications (less accurate)
                            onItemClick={(url, item) => this.handleNotificationClick(url, item)}
                            onMarkAsRead={(item) => this.handleNotificationAsRead(item)}
                            fetchInit={{ credentials: "include" }}
                        />,
                    },
                    {
                        key: "2",
                        label: (
                            <>
                                {isMobile ? <SettingOutlined /> : "System"} {" "}
                                <Badge count={unreadSystemNotifications} overflowCount={99} />
                            </>
                        ),
                        children: <SystemNotificationsList
                            notifications={notifications}        // your current page (mixed types or system-only)
                            loading={loadingNotifications}
                            totalSystemCount={countNotifications.totalSystemNotifications} // add this in your API
                            // onLoadMore={loadMore}                // your existing fetch-more handler
                            onItemClick={(url, item) => this.handleNotificationClick(url, item)}
                            onMarkAsRead={(item) => this.handleNotificationAsRead(item)}
                        />,
                    },
                ]} >

                </Tabs>
            </Drawer>
        );
    }
}

const mapStateToProps = (state) => ({
    loadingNotifications: state.notification.loading,
    notifications: state.notification.notifications,
    countNotifications: state.notification.count,
    unreadNotifications: state.notification?.count?.unreadNotifications ?? 0,
    unreadSystemNotifications: state.notification?.count?.unreadSystemNotifications ?? 0,
    isMobile: state.responsive.isMobile
});

const mapDispatchToProps = (dispatch) => {
    return {
        updateNotificationStatus: (_id) => dispatch(updateNotificationStatus(_id)),
        clearNotifications: () => dispatch(clearNotifications()),
        markNotificationsAsRead: () => dispatch(markNotificationsAsRead())
    };
};

export default
    connect(mapStateToProps, mapDispatchToProps)(NotificationDrawer);
